// extracted by mini-css-extract-plugin
export default {"panel":"b7GCDqirzWLFmhwk8O1K","label":"TvwpXVEDFw3nQtG2BD2J","header":"sYVrZn_0mIrjdUHZqWss"};